export default __webpack_public_path__ + "static/media/IMG-20240708-WA0004.5786fbd1.jpg";